// @vendors
import React, { useEffect } from 'react';

// @components
import RequestsSection from '../../pages/myRequets/components/RequestsSection';
import ProposalsSection from '../../pages/myRequets/components/ProposalsSection';

// @store
import useProposalStore from '../../store/useProposalStore';

const MyRequestsPage: React.FC = () => {
  const { data: proposals, resetListProposal } = useProposalStore();

  useEffect(() => {
    resetListProposal();
  }, [resetListProposal])

  return (
    <div className="w-[100%] grid grid-cols-2 divide-x divide-gray-200 gap-0 h-[80vh] overflow-auto ">
      <RequestsSection />
      <ProposalsSection proposals={proposals?.items || []} />
    </div>
  );
};

export default MyRequestsPage;